import React from 'react'
import { Segment, Grid } from 'semantic-ui-react'
import colors from '../js/colors'

export default () => {
  return (
    <div>
      <Segment inverted style={{ backgroundColor: colors.dark }}>
        <Grid inverted stackable>
          <Grid.Row columns="equal" textAlign="justified" verticalAlign="middle">
            <Grid.Column width={4}>{/* <Icon name="pencil alternate" size="big" color="orange" /> */}</Grid.Column>
            <Grid.Column width={12}>
              <h3 style={{ color: colors.light }}>Projetos</h3>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal" textAlign="justified">
            <Grid.Column>
              <p>Entre em contato conosco, indicaremos os produtos para melhor atender suas necessidades.</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  )
}
